import Axios from "./axios"
import {store} from '../redux/store/store'
import { userData } from "../redux/slices/userSlice";
import { transactionData } from "../redux/slices/userSlice";
import { paymentData } from "../redux/slices/paymentSlice";
 import {data as d} from './data'

export const login = async (data) => {
    // Using dummy data for developemnt.
    // if(data.email == uData.email && data.password == uData.password)
// try {
//     const response =  await Axios.post('?action=login', {
//         data
//     });
//     // console.log(response);
//     if(response.data.success) {
//         store.dispatch(userData(response.data.data));

//         return response.data
     
//     }else{
//         return response;
//     }
   
    
 

// } catch (error) {

//     return error.message;
    
// }

}

export const addUser = async (data) => {

    try {
        const response =  await Axios.post('addUser', {
            data
        });
    
        if(response.data.success) {
            store.dispatch(userData(response.data.data));
    
            return {
                success : true,
                message : response.data.message
        
            };
         
        }else{
            return {
                success : false,
                message : response.data.message
        
            };
        }
       
        
     
    
    } catch (error) {
    
        return error.message;
        
    }
    
}

export const uData = async (navigate) => {
   
        const response = await Axios.get('userData');

        if(response.data.success){

            store.dispatch(userData(response.data.data));
            
        }else{
            navigate('/');
        }
   


    
}

export const userList = async () => {
    const response = await Axios.get('allUsers');

        if(response.data.success)

            store.dispatch(userData(response.data.data));
        
}

export const transaction = async () => {
   
    const response = await Axios.get('transaction');
    if(response.data.success)
      store.dispatch(transactionData(response.data.data));
        
}

export const payment = async () => {

    const response = await Axios.get('payment');
    if(response.data.success)
      store.dispatch(paymentData(response.data.data));
}

export const editUser = async (data) => {


try {
        const response =  await Axios.post('editUser', {
            data
        });
    
        if(response.data.success) {
    
            return {
                success : true,
                message : response.data.message
        
            };
         
        }else{
            return {
                success : false,
                message : response.data.message
        
            };
        }
       
        
     
    
    } catch (error) {
    
        return error.message;
        
    }
    // This should also be able to handle manual funding through the backend. By setting
    // condition to update save to payment if amountToFund is not empty
    
}

